import React from 'react';
import styled from 'styled-components';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import colors from 'constants/styles/colors';

const SCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const SImageWrapper = styled.div`
    width: 100%;
    max-width: 340px;
    max-height: 340px;
    border-radius: 16px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;

    background: ${colors.gray_10};
`;

const SName = styled.div`
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    letter-spacing: 0.01em;
    margin-bottom: 6px;
`;

const SRole = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    letter-spacing: 0.01em;
    text-align: center;
`;

interface Props {
    image: IGatsbyImageData;
    alt: string;
    name: string;
    role: string;
}

export const TeamMemberCard = ({ image, alt, name, role }: Props) => {
    return (
        <SCard>
            <SImageWrapper>
                <GatsbyImage image={image} alt={alt} style={{ width: '100%' }} />
            </SImageWrapper>
            <SName>{name}</SName>
            <SRole>{role}</SRole>
        </SCard>
    );
};
